/**
 * Vasaloppet Mina Sidor
 * Author: Peter Löfås, peter@lofas.se
 * 
 * Creates the FirebaseContext
 */

import React from 'react';
const FirebaseContext = React.createContext(null);
export default FirebaseContext;